<template>
    <div class="conversation-page">
        <v-page-header title="配置会话内容存档" :back="{
                title: '企业微信账号',
                url: '/mng/weworkAccount/index',
            }"
        />
        <v-page-header level="section" title="企业ID">
            <p slot="caption" class="conversation-detail">
                在「企业微信管理后台」-「我的企业」-「企业信息」- 获取企业ID
                <span
                    v-tip:corpIdPreview.hover.delay
                    class="conversation-view"
                >查看图示</span>
            </p>
            <v-tip
                ref="corpIdPreview"
                kind="large"
                placement="right-start"
            >
                <div
                    class="conversation-preview"
                    style="height:507px"
                >
                    <div class="conversation-corpId" />
                </div>
            </v-tip>
        </v-page-header>
        <v-input
            ref="corpId"
            v-model="EnterpriseId"
            :width="480"
            placeholder="请输入企业ID"
        />
        <v-page-header level="section" title="会话内容存档Secret">
            <p slot="caption" class="conversation-detail">
                在「企业微信管理后台」-「管理工具」-「
                <a
                    @click="externalJump('https://work.weixin.qq.com/wework_admin/frame#financial/corpEncryptData')"
                    style="cursor: pointer;"
                >
                    会话内容存档
                </a>
                」-「Secret」中获取
                <span
                    v-tip:sessionPreview.hover.delay
                    class="conversation-view"
                >查看图示</span>
            </p>
            <v-tip
                ref="sessionPreview"
                kind="large"
                placement="right-start"
            >
                <div class="conversation-preview">
                    <div class="conversation-session" />
                </div>
            </v-tip>
        </v-page-header>
        <v-input
            ref="sessionId"
            v-model="sessionContent"
            :width="480"
            name="product"
            placeholder="请输入会话内容存档Secret"
        />
        <v-page-header level="section" title="消息加密公钥">
            <p slot="caption" class="conversation-detail">
                在「企业微信管理后台」-「管理工具」-「
                <a
                    @click="externalJump('https://work.weixin.qq.com/wework_admin/frame#financial/corpEncryptData')"
                    style="cursor: pointer;"
                >
                    会话内容存档
                </a>
                」-「消息加密公钥」中获取
                <span
                    v-tip:msgPreview.hover.delay
                    class="conversation-view"
                >查看图示</span>
            </p>
            <v-tip
                ref="msgPreview"
                kind="large"
                placement="right-start"
            >
                <div class="conversation-preview">
                    <div class="conversation-message" />
                </div>
            </v-tip>
        </v-page-header>
        <div style="overflow: auto">
            <v-textarea
                ref="msgEncryptionCopy"
                v-model="msgEncryption"
                :disabled="true"
                :style="{ width: '480px', height: '240px', float: 'left' }"
                readonly
            />
            <v-copy
                @success="msgCopyCode"
                value="msgEncryptionCopy"
            >
                <div class="conversation-copy" />
            </v-copy>
        </div>
        <v-page-header level="section" title="版本号">
            <p slot="caption" class="conversation-detail">
                在「企业微信管理后台」-「管理工具」-「
                <a
                    @click="externalJump('https://work.weixin.qq.com/wework_admin/frame#financial/corpEncryptData')"
                    style="cursor: pointer;"
                >
                    会话内容存档
                </a>
                」-「消息加密公钥」中获取
                <span
                    v-tip:verPreview.hover.delay
                    class="conversation-view"
                >查看图示</span>
            </p>
            <v-tip
                ref="verPreview"
                kind="large"
                placement="right-start"
            >
                <div class="conversation-preview">
                    <div class="conversation-version" />
                </div>
            </v-tip>
        </v-page-header>
        <v-input
            ref="versionId"
            v-model="versionValue"
            :width="480"
            placeholder="请输入版本号"
        />
        <p class="conversation-prompt">
            配置好后，请勿再点击 “设置”按钮，以免配置参数发生错乱
        </p>
        <div class="conversation-bottom">
            <v-button
                @click="confirmBtn"
                status="primary"
                size="large"
                style="margin-right:12px"
            >
                确定
            </v-button>
            <v-button
                @click="cancelBtn"
                status="default"
                size="large"
            >
                取消
            </v-button>
        </div>
    </div>
</template>

<script>
import '@/utils/ajax';
import Gateway from '@/utils/Gateway';

export default {

    data() {
        return {
            EnterpriseId: '',
            msgEncryption: '',
            sessionContent: '',
            versionValue: '',
            customerValue: '',
        };
    },
    created() {
        this.sessionMsg();
    },
    methods: {
        sessionMsg() {
            Gateway.get('/v1/basic/corp/wework/session')
                .then((res) => {
                    const SessionData = res || {};
                    this.EnterpriseId = SessionData.corp_id;
                    this.msgEncryption = SessionData.public_key;
                    this.sessionContent = SessionData.secret;
                    this.versionValue = SessionData.version;
                    this.customerValue = SessionData.contact_secret;
                })
                .catch((msg) => {
                    this.$message.error(msg || '获取失败');
                });
        },
        externalJump(path) {
            window.open(path, '_blank');
        },
        msgCopyCode() {
            this.$message.success('已复制');
        },
        confirmBtn() {
            const converMsg = [
                { refId: 'corpId', value: this.EnterpriseId, message: '企业ID' },
                { refId: 'sessionId', value: this.sessionContent, message: '会话内容存档Secret' },
                { refId: 'versionId', value: this.versionValue, message: '版本号' },
            ];
            let sessionFlag = true;
            for (let i = 0; i < converMsg.length; i++) {
                if (converMsg[i].value === '') {
                    this.$refs[converMsg[i].refId].focus();
                    this.errorMsg(converMsg[i].message);
                    sessionFlag = false;
                    return;
                }
            }
            if (sessionFlag) {
                Gateway.post('/v1/basic/corp/wework/session/edit', {
                    corp_id: this.EnterpriseId,
                    secret: this.sessionContent,
                    version: this.versionValue,
                    contact_secret: this.customerValue,
                })
                    .then((res) => {
                        this.$message.success(res.message || '保存成功');
                        setTimeout(() => {
                            window.location.href = '/mng/weworkAccount/index';
                        }, 2 * 1000);
                    })
                    .catch((msg) => {
                        this.$message.error(msg || '保存失败');
                    });
            }
        },
        cancelBtn() {
            window.location.href = '/mng/weworkAccount/index';
        },
        errorMsg(errorMsgTxt) {
            this.$message.error(`请填写${errorMsgTxt}`);
        },
    },
};
</script>
<style lang="less" scoped>
@import './conversation-page.less';
</style>
